import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

/**
 * Возвращает категорию инфраструктуры, выбранную в чипсах снизу или в сервисе Транспортной доступности.
 */
export const selectCheckedInfrastructureType = (state: TApplicationState) => state.infrastructure.checkedType;
